<template>
  <div
    v-if="user"
    class="bg-white p-2"
  >
    <h6 class="mb-1 d-flex align-items-center">
      <feather-icon
        icon="InfoIcon"
        :size="'15'"
        color="black"
        class="mr-1"
      />
      <span>More Information</span>
    </h6>

    <b-row>
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="FlagIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Nationality</span>
        </div>
        <div>{{ user.nationality }}</div>
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="CreditCardIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Passport Number</span>
        </div>
        <div>{{ user.passport_number }}</div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="CalendarIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Passport Issue / Expiry</span>
        </div>
        <div v-if="user.passport_issue_date && user.passport_expiry_date">
          ({{ user.passport_issue_date }}) - ({{ user.passport_expiry_date }})
        </div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="CalendarIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Visa Issue / Expiry</span>
        </div>
        <div v-if="user.visa_issue_date && user.visa_expiry_date">
          ({{ user.visa_issue_date }}) - ({{ user.visa_expiry_date }})
        </div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="CalendarIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Labor Card Issue / Expiry</span>
        </div>
        <div v-if="user.labour_card_issue_date && user.labour_card_expiry_date">
          ({{ user.labour_card_issue_date }}) - ({{ user.labour_card_expiry_date }})
        </div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="FileTextIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Contract Start / End</span>
        </div>
        <div v-if="user.contract_start_date && user.contract_end_date">
          ({{ user.contract_start_date }}) - ({{ user.contract_end_date }})
        </div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="CreditCardIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Mode of Payment</span>
        </div>
        <div>{{ user.mode_of_payment }}</div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="DollarSignIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Pension</span>
        </div>
        <div>
          {{ user.pension }} / {{ user.pension_months }} months
        </div>
      </b-col>

      <b-col
        cols="12"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="GlobeIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Website</span>
        </div>
        <a
          v-if="user.website_company"
          :href="user.website_company"
          target="_blank"
        >
          {{ user.website_company }}
        </a>
      </b-col>

      <b-col
        cols="12"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="LinkedinIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>LinkedIn</span>
        </div>
        <a
          v-if="user.linked_in"
          :href="user.linked_in"
          target="_blank"
        >
          {{ user.linked_in }}
        </a>
      </b-col>
    </b-row>

    <!-- Passport / Visa / Labor card uploaded by the engineer from the CE portal -->
    <div class="mt-2">
      <h6 class="mb-1 d-flex align-items-center">
        <feather-icon
          icon="CreditCardIcon"
          :size="'15'"
          color="black"
          class="mr-1"
        />
        <span>Identity Documents</span>
      </h6>
      <b-row>
        <b-col
          v-for="doc in identityDocuments"
          :key="doc.file_type"
          cols="12"
          md="4"
          class="mb-1"
        >
          <div class="font-weight-bold small text-muted d-flex align-items-center">
            <feather-icon
              :icon="doc.icon"
              :size="'15'"
              color="black"
              class="mr-1"
            />
            <span>{{ doc.label }}</span>
          </div>
          <div
            v-if="doc.drive_link"
            class="d-flex align-items-center flex-wrap"
          >
            <a
              :href="doc.drive_link"
              target="_blank"
              rel="noopener noreferrer"
              class="small mr-1"
            >
              View document
            </a>
            <b-badge
              pill
              :variant="statusVariant(doc.status)"
            >
              {{ statusLabel(doc.status) }}
            </b-badge>
          </div>
          <div
            v-else
            class="small text-muted"
          >
            Not uploaded
          </div>
          <div
            v-if="doc.status === 'rejected' && doc.remark"
            class="small text-danger"
          >
            {{ doc.remark }}
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Certificates / Contracts / Additional files -->
    <div class="mt-2">
      <h6 class="mb-1 d-flex align-items-center">
        <feather-icon
          icon="FolderIcon"
          :size="'15'"
          color="black"
          class="mr-1"
        />
        <span>Files</span>
      </h6>
      <div class="mb-1">
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="FileTextIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Certificates</span>
        </div>
        <div class="d-flex flex-wrap">
          <a
            v-for="file in user.employee_certificate_files || []"
            :key="file.id"
            :href="file.url"
            target="_blank"
            class="mr-1 mb-1 small"
          >
            {{ file.name }}
          </a>
        </div>
      </div>
      <div class="mb-1">
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="FileTextIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Contracts</span>
        </div>
        <div class="d-flex flex-wrap">
          <a
            v-for="file in user.employee_contract_files || []"
            :key="file.id"
            :href="file.url"
            target="_blank"
            class="mr-1 mb-1 small"
          >
            {{ file.name }}
          </a>
        </div>
      </div>
      <div>
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="FilePlusIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Additional Files</span>
        </div>
        <div class="d-flex flex-wrap">
          <a
            v-for="file in user.additional_files || []"
            :key="file.id"
            :href="file.url"
            target="_blank"
            class="mr-1 mb-1 small"
          >
            {{ file.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const IDENTITY_DOCUMENTS = [
  { file_type: 'passport', label: 'Passport', icon: 'CreditCardIcon' },
  { file_type: 'visa', label: 'Visa', icon: 'FileTextIcon' },
  { file_type: 'labour_card', label: 'Labor Card', icon: 'BriefcaseIcon' },
]

export default {
  name: 'UserSiteInformationTab',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    identityDocuments() {
      const uploaded = this.user.identity_documents || {}

      return IDENTITY_DOCUMENTS.map(doc => ({
        ...doc,
        ...(uploaded[doc.file_type] || {}),
      }))
    },
  },
  methods: {
    statusVariant(status) {
      if (status === 'approved') return 'light-success'
      if (status === 'rejected') return 'light-danger'
      return 'light-warning'
    },
    statusLabel(status) {
      if (status === 'approved') return 'Approved'
      if (status === 'rejected') return 'Rejected'
      return 'Pending'
    },
  },
}
</script>
